import React, { CSSProperties, ReactNode, useEffect, useState } from "react";
import theme from '../../../assets/themes'

//import { DebugMode } from "../DebugMode";

import { DebugClient } from "../DebugClient";

const ThemeProvider: React.FC<{ children: ReactNode, className: string }> = ({ children, className }) => {
  useEffect(() => {
    document.body.style.setProperty("--bg-color", theme["--bg-color"], "important")
  }, [])
  return <div className={className} style={theme as CSSProperties}>
    {/* <DebugMode /> */}
    <DebugClient />
    {children}
  </div>;
};
export default ThemeProvider;